var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('LoadingIndicator'),_c('NotificationsList'),_c('KeywordModal'),_c('portal-target',{attrs:{"multiple":"","name":"modal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }